<template>
    <div>
        <dx-grid
            url="girlsCampStudents"
            :columns="columns"
            :title="title"
            :selectionEnabled="true"
            :actions="actions"
            ref="grid"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            :beforeSetupGrid="beforeSetupGrid"
            :summaryOptions="{
                enabled: true,
                columns: ['amount', 'fees'],
            }"
        ></dx-grid>
        <v-dialog v-model="changeClassDialog" max-width="500">
            <v-card class="pa-2">
                <v-card-title class="text-warning headline"
                    >Change
                    {{
                        changeClassType == "bunk" ? "Bunk" : "Class"
                    }}</v-card-title
                >
                <v-list>
                    <template v-for="(student, index) in selectedStudents">
                        <v-list-tile avatar ripple>
                            <v-list-tile-content>
                                <v-list-tile-title>{{
                                    student.hName
                                }}</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-divider
                            v-if="index + 1 < selectedStudents.length"
                        ></v-divider>
                    </template>
                </v-list>
                <v-select
                    hide-details
                    class="pr-2 ma-0 px-3 mb-5"
                    :items="getClasses()"
                    :label="changeClassType == 'bunk' ? 'Bunk' : 'Class'"
                    v-model="newClass"
                    box
                    item-text="`${data.item.grade} - ${data.item.teacher}`"
                >
                    <template slot="selection" slot-scope="data">
                        {{ data.item.grade }} -
                        {{ data.item.teacher }}
                    </template>
                    <template slot="item" slot-scope="data">
                        <v-list-tile-content>
                            <v-list-tile-title
                                v-html="
                                    `${data.item.grade} - ${data.item.teacher}`
                                "
                            >
                            </v-list-tile-title>
                        </v-list-tile-content>
                    </template>
                </v-select>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        color="default"
                        @click="changeClassDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :disabled="!newClass.classID"
                        :loading="processing"
                        color="success"
                        @click="updateClass"
                    >
                        confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { formatCurrency, onlyUnique } from "../../utils/helpers.js";
import { loadOptions } from "../../utils/smLookup.js";
import moment from "moment";
import Pusher from "pusher-js";
import axios from "axios";

export default {
    data: () => ({
        title: "Students",
        selectionEnabled: true,
        selectedStudents: [],
        processing: false,
        classes: [],
        changeClassDialog: false,
        newClass: {},
        countries: [],
        regID: "",
        changeClassType: "",

        columns: [
            {
                label: "Name",
                field: "name",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "father",
                label: "Father",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Hebrew Name",
                field: "hName",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Father Hebrew",
                field: "fatherH",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Grade",
                field: "grade",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Class",
                field: "class",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Bunk",
                field: "bunk",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Registration Type",
                field: "regType",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: "NONE",
                selectedFilterOperation: "<>",
            },
            {
                label: "Weeks",
                field: "weeks",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "date",
                label: "Date",
                type: "date",
                format: "",
                visible: false,
                filterType: "",
                format: "MM/dd/yyyy hh:mm:ss a",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "dob",
                label: "DOB",
                type: "date",
                format: "",
                visible: false,
                filterType: "",
                format: "MM/dd/yyyy",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Card Printed",
                field: "cardPrinted",
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: false,
            },
            {
                label: "Lunch Document",
                field: "lunchDoc",
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: false,
            },
            {
                label: "Covid Test",
                field: "covidTest",
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: false,
            },
            {
                label: "Rules Form",
                field: "rulesForm",
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: false,
            },
            {
                label: "HealthForm",
                field: "healthForm",
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: false,
            },
            {
                field: "cardPrintDate",
                label: "Card Print Date",
                type: "date",
                format: "",
                visible: false,
                filterType: "",
                format: "MM/dd/yyyy hh:mm:ss a",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "busCardPrintDate",
                label: "Bus Card Print Date",
                type: "date",
                format: "",
                visible: false,
                filterType: "",
                format: "MM/dd/yyyy hh:mm:ss a",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "bunkCardPrintDate",
                label: "Bunk Card Print Date",
                type: "date",
                format: "",
                visible: false,
                filterType: "",
                format: "MM/dd/yyyy hh:mm:ss a",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Immunizations",
                field: "lastImmunizationDocumentDescription",
                template: "link-action-cell-template",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Has Immunizations",
                field: "hasImmunizationRecords",
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: false,
            },
            {
                label: "Non UTA",
                field: "nonUTA",
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: false,
            },
            {
                label: "Student ID",
                field: "studentID",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "accountID",
                label: "Account ID",
                link: "LapidusAccountView",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Home Phone",
                field: "homePhone",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Cellphone",
                field: "cellPhone",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Address",
                field: "address",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "ZipCode",
                field: "zipCode",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "school",
                label: "School",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "teacherName",
                label: "Teacher Name",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "teacherNumber",
                label: "Teacher Number",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "section",
                label: "Section",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "insuranceCompany",
                label: "Insurance Company",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "insuranceID",
                label: "Insurance ID",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "transportation",
                label: "Transportation",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "note",
                label: "Note",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "amount",
                label: "Camp Fee",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "fees",
                label: "Fees",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
        actions: [],
        pusher: {},
        requestID: "",
    }),
    async created() {
        this.actions.push({
            text: "Change Class",
            action: this.openDialog,
            showOnSelection: true,
        });

        this.actions.push({
            text: "Change Bunk",
            action: this.openBunkDialog,
            showOnSelection: true,
        });

        this.actions.push({
            text: "Print Class List",
            action: this.printClassList,
        });

        const downloadImmunizationAction = {
            text: "Download Immunization Records",
            name: "DownloadImmunizations",
            loading: false,
        };

        downloadImmunizationAction.action = () =>
            this.downloadImmunizationRecords(
                downloadImmunizationAction.loading
            );

        //this.actions.push(downloadImmunizationAction);

        this.columns.find(
            (c) => c.field == "lastImmunizationDocumentDescription"
        ).linkAction = async (student) => {
            const url = await this.$http.get(
                "/api/lapidusDayCamp/GetImmunizationsDocument?filePath=" +
                    student.lastImmunizationDocumentUrl
            );

            return window.open(url);
        };

        await this.loadRegID();

        await this.loadClasses();
        //await this.loadCountries();

        this.subscribeToPusher();
    },
    beforeDestroy() {
        this.pusher.unsubscribe("lapidus-immunizations");
    },
    methods: {
        async beforeSetupGrid() {},
        async loadRegID() {
            this.regID = "GC2020";
        },
        subscribeToPusher() {
            this.pusher = new Pusher("33b9d9d711ad50d8a7ef", {
                cluster: "mt1",
            });

            var channel = this.pusher.subscribe("lapidus-immunizations");

            this.pusher.connection.bind("error", function(err) {
                console.log(err);
            });

            channel.bind("download-immunizations", (message) => {
                this.updateImmunizationActionText(message);
            });
        },
        updateImmunizationActionText(message) {
            if (message.requestID != this.requestID) return;

            const action = this.actions.find(
                (a) => a.name == "DownloadImmunizations"
            );

            const splitted = action.text.split("Records ");

            const text = splitted[0];

            if (!text || !splitted[1]) return;

            const total = splitted[1].split("/")[1];

            const index = +message.index;

            action.text = text + "Records " + index + "/" + total;
        },
        openDialog() {
            this.selectedStudents = this.$refs.grid.getSelectedRowsData();

            this.changeClassDialog = true;
            this.changeClassType = "class";
        },
        openBunkDialog() {
            this.selectedStudents = this.$refs.grid.getSelectedRowsData();

            this.changeClassDialog = true;
            this.changeClassType = "bunk";
        },
        async loadClasses() {
            const classes = await this.$http.get(
                "api/classSetup/get?regID=" + this.regID
            );

            this.classes = classes.filter((c) => {
                return c.regID.trim() == this.regID;
            });
        },
        async loadCountries() {
            this.countries = (await loadOptions("country")).map((c) => c.value);
        },
        async updateClass() {
            this.processing = true;

            const isChangingBunk = this.changeClassType == "bunk";

            const data = {
                students: this.selectedStudents.map((student) => ({
                    studentID: student.studentID,
                    classID: isChangingBunk ? null : this.newClass.classID,
                    bunkID: isChangingBunk ? this.newClass.classID : null,
                })),
            };

            try {
                await this.$http.post(
                    "api/lapidusDayCamp/UpdateClass?user=" +
                        this.$store.state.authentication.user +
                        "&isBunk=" +
                        isChangingBunk +
                        "&setting=" +
                        this.regID,
                    data
                );
            } catch (e) {
                this.processing = false;

                return;
            }

            this.processing = false;

            this.newClass = {};

            this.changeClassDialog = false;
            this.selectedStudents = [];

            this.$refs.grid.reloadGrid();
        },
        async downloadImmunizationRecords() {
            const action = this.actions.find(
                (a) => a.name == "DownloadImmunizations"
            );

            const students = this.$refs.grid.grid.getDataSource().items();

            const immunizations = students
                .filter((s) => s.lastImmunizationDocumentUrl)
                .map((student) => student.studentID);

            if (!immunizations.length) {
                this.$notify({
                    group: "notification",
                    text: "No Immunizations Records for Filetered Students.",
                    type: "warning",
                });

                return;
            }

            action.text =
                "Download Immunization Records " + "0/" + students.length;

            this.requestID = Math.floor(Math.random() * 10000000);

            try {
                const response = await this.$http({
                    url: "api/lapidusDayCamp/getImmunizationsDocumentsInBulk",
                    method: "POST",
                    data: {
                        students: immunizations,
                        classList: this.createClassListHtml(students),
                        requestID: this.requestID,
                    },
                    responseType: "blob",
                });

                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Immunizations.pdf");
                document.body.appendChild(link);
                link.click();
            } catch (e) {
            } finally {
                action.text = "Download Immunization Records";

                this.requestID = "";
            }
        },
        async printClassList() {
            //const students = this.$refs.grid.grid.getDataSource().items();
            //const students2 = this.$refs.grid.grid.store().__rawData;
            const students = await this.$refs.grid.loadAll();

            if (!students.length) return;

            var myWindow = window.open(
                "",
                "Class List",
                "width=768, height=1200"
            );

            myWindow.document.write(this.createClassListHtml(students));
        },
        createClassListHtml(students) {
            const showClass = students.some(
                (s) => s.class != students[0].class
            );

            let html = `<head>
                        <style>
                        table {
                          font-family: arial, sans-serif;
                          border-collapse: collapse;
                          width: 100%;
                        }
                        .nice-text {
                            font-family: arial, sans-serif;
                        }
                        td, th {
                          border: 1px solid #dddddd;
                          text-align: left;
                              padding-right: 3px;
                                padding-left: 2px;
                                padding-top: 4px;
                                padding-bottom: 4px;
                                font-size: 11px;
                        }
                        tr:nth-child(even) {
                          background-color: #dddddd;
                        }
                        .right-align {
                            text-align: right;
                        }
                        </style>
                        </head>`;

            html += `<p class="nice-text right-align">${moment().format(
                "LLL"
            )}</p>`;

            const firstStudentClass = this.classes.find(
                (c) => c.classID == students[0].classID
            );

            const classTitle =
                firstStudentClass.grade + " - " + firstStudentClass.teacher;

            html += showClass
                ? `<h2 class="nice-text">Class List</h2>`
                : `<h2 class="nice-text">Class List - ${classTitle}</h2>`;

            html += `<table>
                            <tr>
                            <th class="right-align">Name</th>
                            <th class="right-align">Father</th>
                            <th>Home Phone</th>
                            <th>Cellphone</th>
                            <th>Registration</th>
                            <th>School</th>
                            <th>Grade</th>
                            <th>Section</th>
                            <th>Bunk</th>
                          `;

            // if (showClass) {
            //     html += `<th>Class</th>`;
            // }

            // html += `
            //                 <th>Weeks</th>
            //                 <th>Section</th>
            //                 <th>School</th>
            //                 <th>Bunk</th>`;

            html += "</tr>";

            students
                .map((student) => {
                    let data = {
                        hebName: student.hName,
                        fatherH: student.fatherH,
                        homePhone: student.homePhone,
                        cellPhone: student.cellPhone,
                        regType: student.regType,
                    };

                    // if (showClass) {
                    //     data.class = student.class;
                    // }
                    data.school = student.school;
                    data.grade = student.grade;
                    data.section = student.section;
                    data.bunk = student.bunk;

                    return data;
                })
                .forEach((student) => {
                    html += `<tr>`;

                    Object.entries(student).forEach((v) => {
                        const field = v[0];
                        const value = v[1];

                        html += ["hebName", "fatherH"].includes(field)
                            ? `<td class="right-align">${value}</td>`
                            : `<td>${value ? value : ""}</td>`;
                    });

                    html += `</tr>`;
                });

            html += `</table>`;

            return html;
        },
        onRowClicked(student) {
            this.$router.push({
                name: "GirlsCampAccountView",
                params: {
                    id: student.accountID,
                },
                query: {
                    studentID: student.studentID,
                },
            });
        },
        getClasses() {
            if (this.changeClassType == "bunk") {
                return this.classes.filter((c) => c.classType == "Bunk");
            } else {
                return this.classes.filter((c) => c.classType != "Bunk");
            }
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
.v-btn__content {
    color: unset;
}
</style>
